import { ScoreChartValues } from "src/components/ScoreChart/ScoreChart";
import { ScoreDimensionValue, ScoreValue } from "src/api/client-api/post/scoreSchema";

export const formatChartData = (headings?: Record<string, ScoreDimensionValue<ScoreValue>>): ScoreChartValues => {
    const valuesObj = headings || {};

    const values = Object.values(valuesObj).flatMap((item) => {
        if (!item.score) {
            return [];
        }
        return {
            value: Number(item.score || 0),
            label: item.label || "",
        };
    });

    return {
        values: values.map((item) => item.value),
        labels: values.map((item) => item.label),
    };
};

export const extractYearFromLabel = (label?: string, fallbackYear: number = new Date().getFullYear()): number => {
    return label ? Number(label.match(/\d+/)?.[0] || fallbackYear) : fallbackYear;
};

export const calculatePercentageDifference = (currentValue: number, baseValue: number): number => {
    return Math.round(((currentValue - baseValue) / Math.abs(baseValue)) * 100);
};
